<script setup>
import { computed, ref } from 'vue';

defineProps({
  locales: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const selected = ref('en');

const activeClasses = computed(() => {
  return 'text-primary border-b-2 border-primary';
});

const handleChange = value => {
  selected.value = value;

  emit('update:modelValue', value);
};
</script>

<template>
  <div class="mb-4" style="z-index: 100">
    <div class="flex select-none pt-4">
      <div class="ml-auto">
        <a
          v-for="(locale, localeKey) in locales"
          :key="localeKey"
          @click="handleChange(localeKey)"
          class="ml-3 cursor-pointer font-bold text-80 text-sm locale-link"
          :class="[selected === localeKey ? activeClasses : '']"
        >
          {{ locale }}
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.locale-link:hover {
  text-decoration: none;
}
</style>
